import React from "react";
import { Aside } from "sprint-common-web";

import { EditDynamicSubtitleAsideContent } from "./EditDynamicSubtitleAsideContent";

export interface EditDynamicSubtitleAsideProps {
    fileRecordId: string;
    isOpen: boolean;
    onCancel(): void;
    onSubmit(): void;
}

export const EditDynamicSubtitleAside: React.FC<EditDynamicSubtitleAsideProps> = (
    props: EditDynamicSubtitleAsideProps
) => {
    const { fileRecordId, isOpen, onSubmit, onCancel } = props;

    return (
        <Aside
            type="form"
            headerText="Edit dynamic subtitle"
            isOpen={isOpen}
            onDismiss={onCancel}
            isLightDismiss={true}
        >
            <EditDynamicSubtitleAsideContent fileRecordId={fileRecordId} onCancel={onCancel} onSubmit={onSubmit} />
        </Aside>
    );
};
